import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
type FaqItem = {
  question: React.ReactNode;
  answer: string;
};
const FAQS: FaqItem[] = [{
  question: <>
        ¿Qué es exactamente Minicookies{' '}
        <span className="text-[#ED93B1]" data-id="element-105">Lab</span>?
      </>,
  answer: 'Es una app web interactiva que abrís desde cualquier navegador, sin descargar nada. Tiene recetas paso a paso, calculadora de precios, gestión de pedidos, guías de venta, packaging y más. Todo en un solo lugar.'
}, {
  question: '¿Cómo recibo el acceso?',
  answer: 'Apenas confirmado el pago recibís un email con el link de acceso y la contraseña. El acceso es inmediato.'
}, {
  question: '¿Funciona en el celular?',
  answer: 'Sí, está optimizada para celular y computadora. Solo necesitás un navegador.'
}, {
  question: '¿Necesito saber hacer cookies antes?',
  answer: 'No. Las recetas son paso a paso y están pensadas para empezar desde cero.'
}, {
  question: '¿El precio incluye actualizaciones?',
  answer: 'Sí. Pagás una sola vez y recibís todas las actualizaciones futuras sin costo adicional.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-8 px-6 lg:px-12 bg-white" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-[#5A3A28]" data-id="element-108">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-109">
          {FAQS.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`rounded-2xl border transition-colors duration-300 overflow-hidden ${isOpen ? 'bg-[#E8B3C1]/20 border-[#E8B3C1]' : 'bg-[#F7F1E8] border-[#5A3A28]/10'}`} data-id="element-110">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-111">
                  <span className="text-lg font-bold text-[#5A3A28]" data-id="element-112">
                    {faq.question}
                  </span>
                  <span className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-[#E8B3C1] text-[#5A3A28]' : 'bg-white text-[#C98A4B]'}`} data-id="element-113">
                    {isOpen ? <Minus className="w-5 h-5" strokeWidth={3} data-id="element-114" /> : <Plus className="w-5 h-5" strokeWidth={3} data-id="element-115" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-116">
                  <div className="overflow-hidden" data-id="element-117">
                    <p className="px-6 pb-5 text-[#5A3A28]/80 font-medium leading-relaxed" data-id="element-118">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}